import React from 'react';
import PropTypes from 'prop-types';

import CourseLevelIcon from '../../common/icons/CourseLevelIcon';

const getLevelText = level => {
  if (level === 1) {
    return 'beginner';
  }

  if (level === 2) {
    return 'intermediate';
  }

  return 'advanced';
};

const CourseLabel = props => {
  return (
    <div>
      <div className="course-label-line" />
      <div className="is-flex align-items-center">
        <CourseLevelIcon level={props.level} />
        <p className="course-label-text">Level: {getLevelText(props.level)}</p>
      </div>
    </div>
  );
};

CourseLabel.propTypes = {
  level: PropTypes.number.isRequired,
};

export default CourseLabel;
